import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Brands.css";

export default class AutoPlay extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: 3000,
      autoplaySpeed: false,
      cssEase: "linear",
    };
    return (
      <div
        data-sal-duration="1200"
        data-sal="slide-up"
        data-sal-delay="100"
        data-sel-easing="ease-out-bounce"
        data-sal-repeat="true"
        style={{ overflow: "hidden" }}
      >
        <h2 className="brands-heading">Our Famous Brands</h2>
        <Slider {...settings} className="slider-brand">
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
          <div>
            <img src={require("../../assets/clikd.png").default} />
          </div>
        </Slider>
      </div>
    );
  }
}
